import React from "react";
import { Box, Tabs, Tab, Stack, IconButton, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Images } from "./../../assets/common";
import PageHeader from "../../components/PageHeader";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import DownloadIcon from "@mui/icons-material/Download";
import AWS from "aws-sdk";
import { S3_BUCKET } from "../../constants/api";
import axios from "axios";
import {
  fullName,
  getErrorString,
  getTimeDue,
  getUserDetail,
  truncate,
} from "./../../constants/function";
import NoData from "../../components/Nodata";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FileName from "../../components/FileName";
import CircularProgressWithLabel from "../../components/CircularProgressWithLabel";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Recordings() {
  const history = useHistory();
  const [show, setShow] = React.useState(null);
  const { t } = useTranslation("common");
  const [loaded, setLoaded] = React.useState(false);
  const [message, setMessage] = React.useState(t("loader.message8"));
  const [recordings, setRecordings] = React.useState([]);
  const [pageNo, setPageNo] = React.useState(1);
  const [progress, setProgress] = React.useState(null);
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [recordingIndex, setRecordingIndex] = React.useState(null);
  const userDetails = getUserDetail();

  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;
    //(a);
    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getRecording(next);
    }
  };
  const getRecording = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.RECORDINGS(
        `pageNo=${next}&pageSize=16`
      );

      setLoaded(response["result"].length < 15 ? true : false);
      setRecordings([...recordings, ...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getRecording(pageNo);
  }, []);
  const handleChange = () => {};
  const download = async (close, index, name) => {
    if (!close) {
      setShow(null);
      return;
    }
    try {
      setRecordingIndex(index);
      setShow(null);
      const url = recordings[index].url;
      setMessage(t("loader.message15"));
      // setLoading(true);
      setProgress(0);
      const options = {
        onDownloadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const pro = Math.floor((loaded * 100) / total);
          setProgress(pro);
          console.log(`Progress: ${pro}`);
        },
      };
      axios
        .get(url, {
          responseType: "blob",
          ...options,
        })
        .then(function (response) {
          console.log(response);

          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          setProgress(null);
          setRecordingIndex(null);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();
        });
    } catch (error) {
      setLoading(false);
      setProgress(null);
      setRecordingIndex(null);
      setMessage(t("loader.message8"));
    }
  };
  return (
    <Box sx={{ padding: "0 22px" }}>
      <PageHeader />
      <Box
        sx={{ width: "75%", backgroundColor: "#090909", position: "relative" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab
            label={t("recording")}
            {...a11yProps(0)}
            sx={{ textTransform: "unset" }}
          />
        </Tabs>

        <Box
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          sx={{ maxHeight: "77vh", overflow: "scroll" }}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box className="__sub_padding" sx={{ position: "relative" }}>
              <Stack
                spacing={1}
                sx={{ height: "60vh", overflow: "scroll" }}
                onScroll={(e) => handleScroll(e.target)}
              >
                {recordings.length > 0 ? (
                  recordings.map((recording, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack direction="row" spacing={1} alignItems="center">
                        <img
                          className="avatar"
                          src={
                            recording?.thumbnailImg?.filePath ||
                            recording?.GIF?.filePath ||
                            Images.default_playlist
                          }
                          alt={recording?.title}
                        />
                        <Stack direction="column">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography className="fs-14">
                              {recording?.title}
                            </Typography>
                            <Typography className="fs-10 faded">
                              {getTimeDue(recording?.createdAt)}
                            </Typography>
                          </Stack>
                          <Typography
                            onClick={() =>
                              userDetails?.hasPremium
                                ? window.open(recording.url, "_blank")
                                : (notifier.error(t("upgrade")),
                                  history.push("/app/Upgrade"))
                            }
                            className="fs-13 fade-text underline _cp"
                            title={
                              userDetails?.hasPremium ? recording?.url : ""
                            }
                          >
                            {truncate(recording?.url, 70)}
                          </Typography>
                        </Stack>
                      </Stack>
                      <IconButton
                        title={t("download")}
                        disabled={typeof progress === "number"}
                        onClick={() =>
                          userDetails?.hasPremium
                            ? setShow(index)
                            : (notifier.error(t("upgrade")),
                              history.push("/app/Upgrade"))
                        }
                      >
                        {progress >= 0 && recordingIndex === index ? (
                          <CircularProgressWithLabel value={progress} />
                        ) : (
                          <DownloadIcon color="primary" />
                        )}
                      </IconButton>
                    </Stack>
                  ))
                ) : (
                  <NoData lable={t("noData.message19")} />
                )}
              </Stack>
            </Box>
          </TabPanel>
        </Box>
        {loading ? (
          <Loader _class="__loader_inside" message={message} wait={true} />
        ) : null}
        {show !== null ? <FileName open={show} handleClose={download} /> : null}
      </Box>
    </Box>
  );
}
